let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9Bneg")).then(() => parcelRequire('7u3NV'));